import {HttpClient} from "@angular/common/http";
import {TranslateLoader} from "@ngx-translate/core";
import { Observable } from 'rxjs/Observable';

import { translations } from './index';

export class LeafTranslateLoader implements TranslateLoader {

  constructor(
    private http: HttpClient,
    private prefix: string = "/assets/i18n/", private suffix: string = ".json") {
  }

  getTranslation(lang: string): any {
    return this.getLeafObservable(lang).combineLatest(this.getHttpSuscriber(lang), (data1, data2) => {
      let response = {};
      Object.assign(response, data1, data2);
      return response;
    });
  }

  private getLeafObservable(lang: any) {
    return Observable.of(translations.get(lang));
  }

  private getHttpSuscriber(lang: string) {
    return this.http.get(`${this.prefix}${lang}${this.suffix}`).map((res: Response) => res.json());
  }
}
